// extracted by mini-css-extract-plugin
export const wrapper = "NativePlantInventories-module--wrapper--1nBRk";
export const graphicWrapper = "NativePlantInventories-module--graphicWrapper--3xHPH";
export const graphic = "NativePlantInventories-module--graphic--6WHhU";
export const line = "NativePlantInventories-module--line--35T5c";
export const mobileGraphic = "NativePlantInventories-module--mobileGraphic--1OcQx";